import {
  ConversationMessage,
  GetConversationMessagesParams,
  GetConversationMessagesResponse,
} from '@stripe-internal/conversations-client';
import {ApiMethods} from './ApiMethods';
import {FrameworkAdapter} from './FrameworkAdapter';

type GetConversationMessagesHandlerDeps = {
  getConversation: (
    conversationId: string,
  ) => ReturnType<ApiMethods['getConversation']>;
};

export class GetConversationMessagesHandler {
  private deps: GetConversationMessagesHandlerDeps;

  constructor(deps: GetConversationMessagesHandlerDeps) {
    this.deps = deps;
  }

  call = async (
    params: GetConversationMessagesParams,
  ): Promise<GetConversationMessagesResponse> => {
    if (!params.conversationId) {
      return {code: 400, error: 'Missing conversationId'};
    }

    const response = await this.deps.getConversation(params.conversationId);
    if (response.type === 'error') {
      return FrameworkAdapter.toClientErrorResponse(response);
    }

    const framework = FrameworkAdapter.fromApiConversation({
      apiConversation: response.data,
      requestContext: {},
    });

    const allMessages = framework.messages;
    const messages: Record<string, ConversationMessage> = params.messageIds
      ? Object.fromEntries(
          params.messageIds
            .filter((id) => id in allMessages)
            .map((id) => [id, allMessages[id]]),
        )
      : allMessages;

    return {code: 200, data: {messages}};
  };
}
